var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19684_27956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8553 3.86929C17.7589 3.64667 17.5991 3.45737 17.3958 3.32501C17.1925 3.19265 16.9547 3.1231 16.7122 3.12504H3.28785C3.04568 3.12504 2.80873 3.19539 2.60579 3.32753C2.40285 3.45967 2.24266 3.64792 2.14469 3.86939C2.04673 4.09086 2.0152 4.33601 2.05394 4.57506C2.09269 4.81411 2.20004 5.03676 2.36294 5.21595L7.5 10.8667V16.9572C7.49985 17.1835 7.56116 17.4056 7.67739 17.5998C7.79362 17.794 7.9604 17.953 8.15993 18.0597C8.35947 18.1665 8.58425 18.2171 8.8103 18.2061C9.03634 18.1951 9.25515 18.1229 9.44336 17.9972L11.9433 16.3307C12.1147 16.2167 12.2552 16.0621 12.3524 15.8806C12.4495 15.6991 12.5002 15.4964 12.5 15.2906V10.8667L17.6371 5.21588C17.8017 5.03767 17.9102 4.81492 17.949 4.57544C17.9878 4.33596 17.9552 4.09036 17.8553 3.86929Z",
    stroke: "#00D998",
    strokeWidth: 1.67
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19684_27956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.afdfacc94e16c946fab589002f3b2339.svg";
export { ForwardRef as ReactComponent };